module.exports = __webpack_public_path__ + "img/1482133754612.f70c5d7a.jpg";